export default "__VITE_ASSET__D4MH_vDH__"